import React from 'react';
import { Menu, Dropdown, Icon } from 'antd';
import { Wrapper } from './StatusChangeDropdown.Styles';

const StatusChangeDropdown = ({ value, onChange }) => {
  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="active">
        <Icon type="fire" theme="twoTone" twoToneColor="#f55742" />
        aktywny
      </Menu.Item>
      <Menu.Item key="archived">
        <Icon type="lock" theme="twoTone" />
        zarchiwizowany
      </Menu.Item>
    </Menu>
  );

  function handleMenuClick(e) {
    // message.info('Click on menu item.');
    onChange(e.key);
  }

  return (
    <>
      <Wrapper>
        <span>{value}</span>
        <Dropdown overlay={menu} trigger={['click']}>
          <a className="ant-dropdown-link" href="#">
            zmień <Icon type="down" />
          </a>
        </Dropdown>
      </Wrapper>
    </>
  );
};

export default StatusChangeDropdown;
